const FIT_MIME = 'application/octet-stream';

export async function shareZwoFile(content: string, filename: string, title?: string): Promise<boolean> {
  const blob = new Blob([content], { type: FIT_MIME });
  const file = new File([blob], filename, { type: FIT_MIME });
  const shareData: ShareData = {
    files: [file],
    title: title?.trim() || filename.replace(/\.[^/.]+$/, '') || 'Workout',
  };

  if (!navigator.share || !navigator.canShare?.(shareData)) {
    return false;
  }

  try {
    await navigator.share(shareData);
    return true;
  } catch (err) {
    const name = err instanceof DOMException ? err.name : (err as Error)?.name;
    if (name === 'AbortError') {
      return true;
    }
    console.error('[shareZwoFile] navigator.share failed:', err);
    return false;
  }
}

export async function shareFitBlob(blob: Blob, filename: string, title?: string): Promise<boolean> {
  const file = new File([blob], filename, { type: FIT_MIME });
  const shareData: ShareData = {
    files: [file],
    title: title?.trim() || filename.replace(/\.[^/.]+$/, '') || 'Workout',
  };

  if (!navigator.share || !navigator.canShare?.(shareData)) {
    return false;
  }

  try {
    await navigator.share(shareData);
    return true;
  } catch (err) {
    const name = err instanceof DOMException ? err.name : (err as Error)?.name;
    if (name === 'AbortError') {
      return true;
    }
    console.error('[shareFitBlob] navigator.share (FIT) failed:', err);
    return false;
  }
}

export function triggerFitDownload(blob: Blob, filename: string): void {
  const typedBlob =
    blob.type === 'application/octet-stream'
      ? blob
      : new Blob([blob], { type: 'application/octet-stream' });
  const url = URL.createObjectURL(typedBlob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.setTimeout(() => URL.revokeObjectURL(url), 120_000);
}
